import {
  deleteStartHypenRegExp,
  onlyNumberRegExp,
  phoneNumberFormatRegExp,
} from 'core/util/regex';

export const phoneNumberFormatter = (string: string): string => {
  if (string.length > 13) return string.slice(0, 13);

  return string
    .replace(onlyNumberRegExp, '')
    .replace(phoneNumberFormatRegExp, '$1-$2-$3')
    .replace(deleteStartHypenRegExp, '');
};
